/* eslint-disable import/prefer-default-export */
/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function acknowledgeNoticationAction(payload) {
  return {
    type: ActionTypes.ACKNOWLEDGE_NOTIFICATION_REQUEST,
    payload,
  };
}
